import { render, staticRenderFns } from "./Transaction.vue?vue&type=template&id=a63aff80&scoped=true&"
import script from "./Transaction.vue?vue&type=script&lang=js&"
export * from "./Transaction.vue?vue&type=script&lang=js&"
import style0 from "./Transaction.vue?vue&type=style&index=0&id=a63aff80&prod&lang=css&"
import style1 from "./Transaction.vue?vue&type=style&index=1&id=a63aff80&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a63aff80",
  null
  
)

export default component.exports